<template>
		<c-modal @close="close" :title="client_id === 1 ? 'Nieuwe Reuzado medewerker' : 'Nieuwe contactpersoon '">
            <c-form ref="form" @valid="submit">

                <c-personal-data
                    ref="personalform"
                    :contact="data"
                    :edit="editing">
                </c-personal-data>

                <c-checkbox
                    :label="'Eindklanten'"
                    :horizontal="true"
                    :options="endclients"
                    :labeltext="'name'"
                    v-model="endClients">
                </c-checkbox>

                <div class="row collapse align-right">
                    <div class="columns shrink">
                        <c-button class="margin-t-32 margin-b-16 no-margin-b" type="submit">{{ editing ? 'Wijzig' : 'Toevoegen' }}</c-button>
                    </div>
			    </div>

            </c-form>
        </c-modal>
</template>

<script>
import Form from '@mixins/Form';
import CPersonalData from '@components/PersonalData';
import CModal from '@components/Modal';
import { ValidationError } from '@app/errors';

export default {
	mixins: [Form],
	components: {
		CPersonalData, CModal
	},
	props: {
		client_id: {
			required: false
		},
        data: {
            type: Object,
            default: {}
        },
        endclients: {
            type: Array,
            default: []
        }
    },
    data() {
        return {
            editing: false,
            endClients: {}
        }
    },
	methods: {
        close() {
            this.$refs.personalform.clearData()
            this.editing = false;
            this.$emit('close');
		},
		submit() {

            let data = this.$refs.personalform.getData();
            data.client_id = this.client_id;
            data.endClients = this.endClients;
            
            // If email is null, remove it from the data object

            if (data.email === null) {
                delete data.email;
            }
            if (data.phone === null) {
                delete data.phone;
            }
           
            if (this.editing) {
                this.$xhr.put('/api/contacts/'+ data.id, data).then( ( {result}) => {
                    this.$emit('submit:success')
                    this.$store.dispatch('toast/success', {title: 'Medewerker aanmaken', text: 'De medewerker is aangemaakt'});
                    this.close();

                }).catch( (e) => {
                    if (e instanceof ValidationError) {
                        this.$refs.form.setErrors(e.errors);
                    }
                    this.$store.dispatch('toast/alert', {title: 'Medewerker aanmaken', text: 'Er is helaas iets fout gegaan bij het aanmaken van de medewerker'});
                });
            } else {
                this.$xhr.post('/api/contacts', data).then( ( {result}) => {
                    this.$store.dispatch('toast/success', {title: 'Medewerker aanmaken', text: 'De medewerker is aangemaakt'});
                    this.$emit('submit:success')
                    this.close();
                }).catch( (e) => {
                    if (e instanceof ValidationError) {
                        this.$refs.form.setErrors(e.errors);
                    }
                    this.$store.dispatch('toast/alert', {title: 'Medewerker aanmaken', text: 'Er is helaas iets fout gegaan bij het aanmaken van de medewerker'});
                });
            }

        }
    },
    watch: {
        data(newVal) {
            this.editing = Object.values(newVal).length !== 0 && newVal.constructor === Object;
            if(Array.isArray(this.data.reseller_end_client)){
                this.endClients = []
                this.data.reseller_end_client.map( (endclient) => {
                    this.endClients.push(endclient.endclient_id)
                });
            }
            else {
                this.endClients = [];
            }
        },
      
    },
    mounted(){
        if(this.data.reseller_end_client){
            this.endClients.push(endclient.endclient_id)
        }
        else {
            this.data.reseller_end_client = {}
            this.endClients = [];
        }
    }
}
</script>
